import Quill from 'quill'
import emojiMap from './emoji-map'

const Embed = Quill.import('blots/embed')

class EmojiBlot extends Embed {
    static create (value) {
        let span = document.createElement('span')
        let emojiPars = value.split('::')
        let emoji = emojiMap[emojiPars[0]]

        if (emoji) {
            span.setAttribute('data-short-name', emoji.short_name)
            if (emojiPars[1]) {
                let skintTonesMap = {
                    'skin-tone-2': '1F3FB',
                    'skin-tone-3': '1F3FC',
                    'skin-tone-4': '1F3FD',
                    'skin-tone-5': '1F3FE',
                    'skin-tone-6': '1F3FF'
                }

                span.setAttribute('data-skin-tone', emojiPars[1])
                span.innerText = String.fromCodePoint(...this.parseUnicode(emoji.skin_variations[skintTonesMap[emojiPars[1]]].unified))
            } else {
                span.innerText = String.fromCodePoint(...this.parseUnicode(emoji.unified))
            }
            span.classList.add('ql-emojiblot')
        }

        return span
    }

    static value (node) {
        let value = `:${node.dataset.shortName}:`

        if (node.dataset.skinTone) {
            value += `:${node.dataset.skinTone}:`
        }

        return value
    }

    static parseUnicode (string) {
        return string.split('-').map(str => parseInt(str, 16))
    }
}

EmojiBlot.blotName = 'emoji'
EmojiBlot.tagName = 'span'

Quill.register({
    'formats/emoji': EmojiBlot
})
